import { EventDrivenStore } from '@core/store/eventDrivenStore';
import constants from '@core/utils/constants';

class CustomersStore extends EventDrivenStore {
  constructor() {
    const defaultState = {
      list_all: {
        list: [],
        total: 0,
        error: null,
        loading: true
      },

      detail: {
        data: null,
        error: null,
        loading: true
      }
    };
    super('customers', defaultState, {
      useLocalStorage: false
    });
    this.defaultState = defaultState;
  }

  async setupEvents() {
    this.on(constants.EVENTS.CUSTOMERS.DETAIL.REFRESH, () => {
      this.state.detail.loading = true;
      this.state.detail.error = null;
      this.state.detail.data = null;
    });
    this.on(constants.EVENTS.CUSTOMERS.DETAIL.REFRESHED, (data) => {
      this.state.detail.data = data;
      this.state.detail.loading = false;
      this.state.detail.error = null;
    });
    this.on(constants.EVENTS.CUSTOMERS.DETAIL.REFRESH_ERROR, (error) => {
      this.state.detail.loading = false;
      this.state.detail.error =
        error?.message || error || "Une Erreur inconnue s'est produite";
    });

    this.on(constants.EVENTS.CUSTOMERS.LIST_ALL.REFRESHING, () => {
      this.state.list_all.loading = true;
      this.state.list_all.error = null;
      this.state.list_all.list = [];
      this.state.list_all.total = 0;
    });
    this.on(constants.EVENTS.CUSTOMERS.LIST_ALL.REFRESHED, (data) => {
      this.state.list_all.list = Array.isArray(data) ? data : [];
      this.state.list_all.total = 100;
      this.state.list_all.loading = false;
      this.state.list_all.error = Array.isArray(data)
        ? null
        : 'Mauvais format de donnée';
    });
    this.on(constants.EVENTS.CUSTOMERS.LIST_ALL.REFRESH_ERROR, (error) => {
      this.state.list_all.loading = false;
      this.state.list_all.error =
        error?.message || error || "Une Erreur inconnue s'est produite";
    });
  }
}

export default CustomersStore;
